export default __webpack_public_path__ + "static/media/battery.9bf0e1aa.png";